<div class="h-full w-full si-card">
    <div class="flex flex-row grow-0 border-b px-4 py-2">
        <div class="flex grow items-center">
            <h3 class="pt-2 whitespace-nowrap">Sessions</h3>
        </div>
        <div class="flex grow-0 items-center">
            <mat-button-toggle-group name="type" class="mr-1 card-toggle-btn">
                <mat-button-toggle value="CHART" [checked]="isShowChart"
                    (click)="isShowChart = true" class="flex items-center">
                    <fa-icon matTooltip="Chart" class="si-icon" [icon]="['fal', 'chart-column']"></fa-icon>
                </mat-button-toggle>
                <mat-button-toggle value="TABLE" [checked]="!isShowChart"
                    (click)="isShowChart = false" class="flex items-center">
                    <fa-icon matTooltip="Table" class="si-icon" [icon]="['fal', 'table']"></fa-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div>
    <div class="flex flex-col h-full w-full p-4 relative overflow-hidden">
        <p class="card-sub-header-text">Total sessions by source over the past 4 weeks</p>

        <app-sessions-card
            class="flex flex-col h-full overflow-hidden w-full"
            [isShowChart]="isShowChart"
            [sessionSummary]="sessionSummary$ | async"
        ></app-sessions-card>

    </div>
</div>
